import { Field, NumericInput, TextOutput } from '../../../../Core';
import { FieldSet } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { hasEmptyValue, hasNonEmptyValue, hasValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { DisplacementGaugeItem } from '../../types';

let EquipmentDisplacementGaugeFieldSetBase: React.FC<IWorksheetComponent & { name: string }> = ({
  createWorksheetSelector,
  name,
}) => {
  const gauge = useSelector(createWorksheetSelector!(`${name}`), deepEquals) as DisplacementGaugeItem;
  const gaugeFactor = useSelector(createWorksheetSelector!(`${name}.Results.Factor`), deepEquals);
  const readability = useSelector(createWorksheetSelector!(`${name}.Results.Readability`));
  const calibrationMismatch = useSelector(createWorksheetSelector!(`${name}.CalibrationMismatch`)) as boolean;
  const importMismatch = useSelector(createWorksheetSelector!(`${name}.Mismatch`)) as boolean;

  return (
    <FieldSet>
      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="deflection-gauge"
        name={name}
        importedCalibration={{
          Mismatch: calibrationMismatch,
          Factor: gaugeFactor,
        }}
        importedAdditionalData={{
          Mismatch: importMismatch,
          Readability: readability,
        }}
        importModel={{ Id: gauge?.Id }}
      />
      <Field input={<TextOutput />} name={`${name}.Results.Readability`} visible={hasValue(readability)} />
      <Field input={<TextOutput />} name={`${name}.Results.Factor`} visible={hasNonEmptyValue(gauge?.Factor)} />
      <Field input={<NumericInput />} name={`${name}Factor`} visible={hasEmptyValue(gauge?.Factor)} />
    </FieldSet>
  );
};

const EquipmentDisplacementGaugeFieldSet = withInjectedProps(EquipmentDisplacementGaugeFieldSetBase);
export { EquipmentDisplacementGaugeFieldSet };
export default EquipmentDisplacementGaugeFieldSet;
